import logo from '../../assets/img/logo_cite.svg';
import PropTypes from 'prop-types';

function Logo({ size = "100%", className = 'logo' }) {
  return <img src={logo} width={size} className={className} alt="Accueil Cité des sciences et de l'industrie" />
}

Logo.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.string
}

export default Logo;
